import React from 'react';
import { AppBar, Toolbar, IconButton, Tooltip, Box } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PreviewIcon from '@mui/icons-material/Preview';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RoomIcon from '@mui/icons-material/Room';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // ✅ NEW Approve Icon

const RibbonNavbar = ({
  showAdd,
  showEdit,
  showView,
  showDelete,
  showManageProfile,
  onAdd,
  onEdit,
  onView,
  onDelete,
  onManageProfile,
  disabledEdit = false,
  disabledView = false,
  disabledDelete = false,
  disabledManageProfile = false,

  showAssignLocation,
  onAssignLocation,
  disabledAssignLocation = false,

  showAssignRoute,
  onAssignRoute,
  disabledAssignRoute = false,

  showAssignRole,
  onAssignRole,
  disabledAssignRole = false,

  // ✅ NEW props
  showApprove,
  onApprove,
  disabledApprove = false,
}) => {
  const goldenColor = '#042d8c';

  const baseIconStyle = {
    color: goldenColor,
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
    transition: 'all 0.3s ease',
    borderRadius: '12px',
    padding: '5px',
    marginTop: '-30px',
    '&:hover': {
      transform: 'scale(1.2)',
      boxShadow: '0 0 15px rgba(255, 215, 0, 0.6)',
    },
  };

  return (
    <Toolbar sx={{ justifyContent: 'left', minHeight: 40 }}>
      <Box sx={{ display: 'flex', gap: 5 }}>

        {/* Add */}
        {showAdd && (
          <Tooltip title="Add">
            <IconButton
              onClick={onAdd}
              sx={{
                ...baseIconStyle,
                '&:hover': { ...baseIconStyle['&:hover'], backgroundColor: '#f2f5fa' },
              }}
            >
              <AddCircleOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {/* Edit */}
        {showEdit && (
          <Tooltip title="Edit">
            <IconButton
              onClick={onEdit}
              disabled={disabledEdit}
              sx={{
                ...baseIconStyle,
                opacity: disabledEdit ? 0.4 : 1,
                '&:hover': { ...baseIconStyle['&:hover'], backgroundColor: '#f2f5fa' },
              }}
            >
              <EditNoteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {/* View */}
        {showView && (
          <Tooltip title="View">
            <IconButton
              onClick={onView}
              disabled={disabledView}
              sx={{
                ...baseIconStyle,
                opacity: disabledView ? 0.4 : 1,
                '&:hover': { ...baseIconStyle['&:hover'], backgroundColor: '#f2f5fa' },
              }}
            >
              <PreviewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {/* Delete */}
        {showDelete && (
          <Tooltip title="Delete">
            <IconButton
              onClick={onDelete}
              disabled={disabledDelete}
              sx={{
                ...baseIconStyle,
                opacity: disabledDelete ? 0.4 : 1,
                '&:hover': { ...baseIconStyle['&:hover'], backgroundColor: '#f2f5fa' },
              }}
            >
              <DeleteForeverIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {/* Manage Profile */}
        {showManageProfile && (
          <Tooltip title="Manage Profile">
            <IconButton
              onClick={onManageProfile}
              disabled={disabledManageProfile}
              sx={{
                ...baseIconStyle,
                opacity: disabledManageProfile ? 0.4 : 1,
                '&:hover': { ...baseIconStyle['&:hover'], backgroundColor: '#f2f5fa' },
              }}
            >
              <ManageAccountsIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {/* Assign Location */}
        {showAssignLocation && (
          <Tooltip title="Assign Item Location">
            <IconButton
              onClick={onAssignLocation}
              disabled={disabledAssignLocation}
              sx={{
                ...baseIconStyle,
                opacity: disabledAssignLocation ? 0.4 : 1,
                '&:hover': { ...baseIconStyle['&:hover'], backgroundColor: '#f2f5fa' },
              }}
            >
              <RoomIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {/* Assign Route */}
        {showAssignRoute && (
          <Tooltip title="Assign Route">
            <IconButton
              onClick={onAssignRoute}
              disabled={disabledAssignRoute}
              sx={{
                ...baseIconStyle,
                opacity: disabledAssignRoute ? 0.4 : 1,
                '&:hover': { ...baseIconStyle['&:hover'], backgroundColor: '#f2f5fa' },
              }}
            >
              <AltRouteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {/* Assign Role */}
        {showAssignRole && (
          <Tooltip title="Assign Role">
            <IconButton
              onClick={onAssignRole}
              disabled={disabledAssignRole}
              sx={{
                ...baseIconStyle,
                opacity: disabledAssignRole ? 0.4 : 1,
                '&:hover': { ...baseIconStyle['&:hover'], backgroundColor: '#f2f5fa' },
              }}
            >
              <AdminPanelSettingsIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {/* ✅ NEW: Approve Order */}
        {showApprove && (
          <Tooltip title="Approve Order">
            <IconButton
              onClick={onApprove}
              disabled={disabledApprove}
              sx={{
                ...baseIconStyle,
                opacity: disabledApprove ? 0.4 : 1,
                '&:hover': { ...baseIconStyle['&:hover'], backgroundColor: '#f2f5fa' },
              }}
            >
              <CheckCircleIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

      </Box>
    </Toolbar>
  );
};

export default RibbonNavbar;
